import React, { useState } from 'react';
import PreviewImage from '../image-preview';
import UploadImage from '../upload-image';

interface IProps {
  previewImage: string;
  setPreviewImage: any;
  setFieldValue: any;
  label?: string;
  name?: string;
  isHidden?: any;
  setIsHidden?: any;
  hideCross?: boolean;
}

const LogoUploadWithPreview: React.FC<IProps> = ({
  name,
  previewImage,
  setPreviewImage,
  setFieldValue,
  hideCross = false,
  label,
}) => {
  const handleChange = (file: any) => {
    setFieldValue('logo', file);

    setPreviewImage(file);
    // setFieldValue('logo', file);
  };

  return (
    <>
      {previewImage ? (
        <>
          <PreviewImage
            file={previewImage}
            hideCross={hideCross}
            label={label}
            onClick={() => {
              setPreviewImage(null);
              setFieldValue('logo', '');
            }}
          />
        </>
      ) : (
        <UploadImage
          onChange={handleChange}
          name={'logo'}
          label={label}
          setFieldValue={setFieldValue}
        />
      )}
    </>
  );
};

export default React.memo(LogoUploadWithPreview);
